'use client';

import { Tooltip } from '@pickleballinc/react-ui';
import clsx from 'clsx';
import { useRouter, useSearchParams } from 'next/navigation';

interface StatusCardProps {
  title: string;
  value: string;
  isClickable?: boolean;
  shouldShowTooltip?: boolean;
}

export const StatusCard = ({ title, value, isClickable, shouldShowTooltip }: StatusCardProps) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const isChecked = searchParams?.get('type') === title;
  const onClick = () => {
    if (!isClickable) {
      return;
    }
    const newSearchParams = new URLSearchParams(searchParams || '');
    const type = searchParams?.get('type');
    newSearchParams.delete('current_page');
    if (type === title) {
      newSearchParams.delete('type');
    } else {
      newSearchParams.set('type', title);
    }
    router.replace(`?${newSearchParams.toString()}`, { scroll: false });
  };

  return (
    <div>
      {!shouldShowTooltip ? (
        <div
          className={clsx(
            'flex flex-1 items-center justify-between rounded-lg bg-gray-100 p-4 shadow-md',
            {
              'cursor-pointer': isClickable,
              'bg-gray-300': isChecked,
            }
          )}
          onClick={onClick}
          role='presentation'
        >
          <div>
            <p className='text-sm text-gray-500'>{title}</p>
            <p className='text-3xl font-semibold text-gray-900'>{value}</p>
          </div>
        </div>
      ) : (
        <Tooltip placement='bottom'>
          <Tooltip.Trigger asChild>
            <div
              className={clsx(
                'flex flex-1 items-center justify-between rounded-lg bg-gray-100 p-4 shadow-md',
                {
                  'cursor-pointer': isClickable,
                  'bg-gray-300': isChecked,
                }
              )}
              onClick={onClick}
              role='presentation'
            >
              <div>
                <p className='text-sm text-gray-500'>{title}</p>
                <p className='text-3xl font-semibold text-gray-900'>{value}</p>
              </div>
            </div>
          </Tooltip.Trigger>
          <Tooltip.Content>
            <p>Filtering by Skinny Singles is not available for organizations using DUPR.</p>
          </Tooltip.Content>
        </Tooltip>
      )}
    </div>
  );
};
